export interface EventDynamic {
  id: string;
  title: string;
  date: string;
}

export interface EventItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  categoryId: string;
  categoryName: string;
  region: string;
  date: string;
  views: number;
  host: string;
  location: string;
  tags: string[];
  intro: string;
  content: string[];
  dynamics: EventDynamic[];
  featured?: boolean;
}

export const events: EventItem[] = [
  {
    id: 'evt-01',
    title: '2026星耀网红歌唱大赛总决赛落幕 神秘唱将逆袭夺冠',
    summary: '历经三个月的层层选拔，2026星耀网红歌唱大赛总决赛昨晚圆满收官，一位此前默默无闻的选手凭借原创曲目完成惊天逆袭。',
    cover:
      'https://readdy.ai/api/search-image?query=Winner%20holding%20a%20golden%20trophy%20on%20an%20award%20stage%20with%20orange%20warm%20spotlights%20and%20confetti%2C%20happy%20young%20host%2C%20modern%20event%20photography%2C%20clean%20background&width=800&height=600&seq=wldg-cover-08&orientation=landscape',
    categoryId: 'singing',
    categoryName: '网红歌唱赛',
    region: '全国',
    date: '2026-10-10',
    views: 328000,
    host: '每日大瓜赛事组委会',
    location: '北京·国家会议中心',
    tags: ['总决赛', '歌唱', '逆袭'],
    intro: '2026星耀网红歌唱大赛自七月启动以来，累计吸引超过两千名网络歌手报名参赛，昨晚的总决赛成为本届赛事关注度最高的一战。',
    content: [
      '总决赛共设置三轮演唱，选手需要在限定时间内完成翻唱、合作曲目与原创曲目三个环节。赛前夺冠呼声最高的三位人气选手在首轮表现稳定，但进入原创环节后，一位此前从未进入过热搜的选手以一首自己创作的作品瞬间点燃全场。',
      '现场评委点评称，这首原创作品在旋律与叙事上都展现了超出新人水准的成熟度，最终该选手以微弱优势反超，夺得本届大赛年度冠军。',
      '赛后冠军接受采访时表示，自己坚持创作已有五年，这次参赛是想让更多人听到普通人的声音。赛事主办方透露，明年将扩大赛区覆盖范围，并增设原创扶持计划。',
    ],
    dynamics: [
      { id: 'evt-01-d1', title: '总决赛完整回放上线 三小时播放量破百万', date: '2026-10-11' },
      { id: 'evt-01-d2', title: '冠军原创单曲即将发行 制作团队首次公开', date: '2026-10-09' },
      { id: 'evt-01-d3', title: '评委阵容幕后花絮曝光 彩排现场欢乐不断', date: '2026-10-07' },
    ],
    featured: true,
  },
  {
    id: 'evt-02',
    title: '街舞女神对决火爆全网 网红舞蹈大赛八强诞生',
    summary: '网红舞蹈大赛迎来最受期待的街舞专场，多位实力派舞者同台飙舞，八强名单在观众投票中正式揭晓。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20dancer%20mid%20spin%20on%20a%20street%20dance%20battle%20stage%20with%20orange%20and%20cyan%20lighting%2C%20energetic%20pose%2C%20modern%20event%20photography%2C%20clean%20simple%20dark%20background&width=800&height=600&seq=wldg-cover-02&orientation=landscape',
    categoryId: 'dance',
    categoryName: '网红舞蹈赛',
    region: '上海',
    date: '2026-10-08',
    views: 276000,
    host: '星耀传媒',
    location: '上海·梅赛德斯文化中心',
    tags: ['街舞', '八强', '对决'],
    intro: '本场街舞专场是网红舞蹈大赛开赛以来竞争最激烈的一轮，选手们在两分钟内完成自编作品的呈现。',
    content: [
      '开场便是一场高难度的地板动作对拼，两位选手几乎同时完成令人瞠目的空中定格，引发现场阵阵惊呼。评审席上多位资深舞者表示，本届选手的整体技术已经接近职业水准。',
      '在观众实时投票环节，一段融合了国风元素的街舞作品脱颖而出，短时间内登上同城热搜榜前列，也让更多人开始关注网络舞者的成长。',
      '最终八强名单在当晚正式公布，主办方透露下一轮将采用随机抽签组队的方式，增加赛事的悬念与可看性。',
    ],
    dynamics: [
      { id: 'evt-02-d1', title: '八强选手专访：舞台背后的魔鬼训练日常', date: '2026-10-09' },
      { id: 'evt-02-d2', title: '国风街舞作品出圈 视频播放量破八百万', date: '2026-10-07' },
      { id: 'evt-02-d3', title: '下轮赛制曝光 随机组队引爆期待', date: '2026-10-05' },
    ],
    featured: true,
  },
  {
    id: 'evt-03',
    title: '直播PK赛进入白热化 三位头部主播单场流水破千万',
    summary: '本周直播PK赛迎来高能赛段，三位头部主播在同一晚联动开播，单场互动与成交数据接连刷新赛事纪录。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    categoryId: 'pk',
    categoryName: '直播PK赛',
    region: '全国',
    date: '2026-10-06',
    views: 254000,
    host: '每日大瓜赛事组委会',
    location: '线上直播间',
    tags: ['PK', '纪录', '头部主播'],
    intro: '直播PK赛进入后半程，赛事组委会调整了连麦规则，让更多人气主播有机会同台竞技。',
    content: [
      '本场赛事的看点在于三位头部主播首次在同一时间段联动开播，观众可以在不同直播间之间切换为喜欢的选手助威。',
      '据赛事公开数据，当晚三人的互动总量与成交数据均创下开赛以来的新高，其中一位主播在最后一轮实现反超，锁定小组第一。',
      '赛事方表示，后续将加入更多观众参与机制，让普通观众也能通过投票影响赛程走向。',
    ],
    dynamics: [
      { id: 'evt-03-d1', title: '连麦规则升级 观众投票权重大幅提升', date: '2026-10-07' },
      { id: 'evt-03-d2', title: '单场数据创新高 赛事方公布完整榜单', date: '2026-10-06' },
      { id: 'evt-03-d3', title: '三位主播赛后合体直播 回应争议话题', date: '2026-10-04' },
    ],
    featured: true,
  },
  {
    id: 'evt-04',
    title: '网红带货超级联赛开赛 首场成交额刷新纪录',
    summary: '网红带货超级联赛正式鸣锣开赛，首场助农专场成绩亮眼，多款地方特产在直播间被抢购一空。',
    cover:
      'https://readdy.ai/api/search-image?query=Smiling%20young%20host%20presenting%20products%20during%20a%20lively%20live%20selling%20show%20with%20orange%20accents%2C%20bright%20studio%20lighting%2C%20modern%20e-commerce%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-04&orientation=landscape',
    categoryId: 'ecommerce',
    categoryName: '网红带货赛',
    region: '广东',
    date: '2026-10-04',
    views: 231000,
    host: '优品直播联盟',
    location: '广州·直播产业基地',
    tags: ['带货', '助农', '成交纪录'],
    intro: '网红带货超级联赛以“真实、专业、可持续”为宗旨，考察主播的选品能力、讲解力与转化能力。',
    content: [
      '首场比赛以助农为主题，参赛主播需要在限定时间内完成地方特产的讲解与推荐，评分由成交数据与专业评委共同决定。',
      '多款来自山区的农副产品在直播间被抢购一空，部分单品在上架数分钟内即宣布售罄，显示出赛事与助农结合的良好效果。',
      '赛事主办方表示，后续还将设置国货专场与数码专场，持续为国产品牌提供展示舞台。',
    ],
    dynamics: [
      { id: 'evt-04-d1', title: '助农专场战报出炉 多款特产售罄', date: '2026-10-05' },
      { id: 'evt-04-d2', title: '国货专场阵容公布 众多品牌确认参与', date: '2026-10-03' },
      { id: 'evt-04-d3', title: '主播选品培训课上线 助力新人快速成长', date: '2026-10-01' },
    ],
    featured: true,
  },
  {
    id: 'evt-05',
    title: '才艺挑战赛惊现民间绝活 素人选手一夜涨粉百万',
    summary: '才艺挑战赛首轮海选爆出冷门，一位此前毫无知名度的素人选手凭借一手绝活惊艳全场，一夜之间涨粉百万。',
    cover:
      'https://readdy.ai/api/search-image?query=Talented%20young%20performer%20showing%20skills%20on%20a%20variety%20talent%20stage%20with%20warm%20gold%20orange%20lighting%2C%20excited%20expression%2C%20modern%20event%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-05&orientation=landscape',
    categoryId: 'talent',
    categoryName: '才艺挑战赛',
    region: '四川',
    date: '2026-10-02',
    views: 198000,
    host: '蓉城文化传媒',
    location: '成都·天府演艺中心',
    tags: ['才艺', '素人', '出圈'],
    intro: '才艺挑战赛面向所有普通创作者开放，只要有一技之长都可以登台展示，因此常被称作“民间高手孵化器”。',
    content: [
      '本轮海选中，一位来自县城的选手带来了一段融合传统技艺与现代表演的节目，现场观众与线上观众几乎同时沸腾。',
      '节目片段在社交平台迅速传播，短短一夜之间，该选手的关注量增长超过百万，成为本届赛事最具话题度的黑马。',
      '赛事评委表示，才艺挑战赛最动人的地方，正是让那些默默坚持的普通人被更多人看见。',
    ],
    dynamics: [
      { id: 'evt-05-d1', title: '素人选手爆红幕后：十年坚持终被看见', date: '2026-10-03' },
      { id: 'evt-05-d2', title: '海选精彩片段合集上线 播放量持续攀升', date: '2026-10-01' },
      { id: 'evt-05-d3', title: '下一轮增设团队赛 邀请人气选手带队', date: '2026-09-29' },
    ],
    featured: true,
  },
  {
    id: 'evt-06',
    title: '公益主播大赛温暖收官 累计募集善款超两千万',
    summary: '为期一个月的公益主播大赛圆满落幕，参赛主播将直播收益的一部分捐赠给乡村教育与助农项目。',
    cover:
      'https://readdy.ai/api/search-image?query=Group%20of%20friendly%20young%20streamers%20volunteering%20at%20a%20charity%20broadcast%20event%20with%20orange%20warm%20tones%2C%20smiling%20faces%2C%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-06&orientation=landscape',
    categoryId: 'charity',
    categoryName: '公益主播赛',
    region: '北京',
    date: '2026-09-28',
    views: 176000,
    host: '每日大瓜公益基金',
    location: '北京·公益直播基地',
    tags: ['公益', '助农', '收官'],
    intro: '公益主播大赛以“让流量有温度”为口号，鼓励主播用直播的形式参与公益，记录真实的善意。',
    content: [
      '赛事期间，参赛主播走进乡村、学校与社区，用镜头记录需要被看见的故事，并将专项直播收益捐赠给对应项目。',
      '据组委会统计，本届大赛累计募集善款超过两千万元，款项将定向用于乡村教室改造与农产品助销。',
      '多位主播在收官仪式上表示，参与公益赛让他们重新思考了流量的意义，也希望把这份善意延续到日常直播中。',
    ],
    dynamics: [
      { id: 'evt-06-d1', title: '公益赛善款使用明细首次公开', date: '2026-09-29' },
      { id: 'evt-06-d2', title: '山区教室改造项目正式动工', date: '2026-09-27' },
      { id: 'evt-06-d3', title: '主播公益日记连载 记录真实乡村行', date: '2026-09-25' },
    ],
  },
  {
    id: 'evt-07',
    title: '新生代女团空降歌唱大赛舞台 现场气氛燃爆',
    summary: '歌唱大赛迎来惊喜嘉宾，一支新生代女团空降现场助阵，与选手同台合作带来高能舞台。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20female%20singer%20performing%20on%20a%20colorful%20competition%20stage%20with%20warm%20orange%20spotlight%2C%20microphone%20in%20hand%2C%20modern%20event%20photography%2C%20clean%20bright%20simple%20studio%20background&width=800&height=600&seq=wldg-cover-01&orientation=landscape',
    categoryId: 'singing',
    categoryName: '网红歌唱赛',
    region: '湖南',
    date: '2026-09-25',
    views: 165000,
    host: '芒果娱乐',
    location: '长沙·演播大厅',
    tags: ['嘉宾', '合作舞台', '女团'],
    intro: '本轮歌唱大赛邀请到一支人气女团担任飞行嘉宾，与晋级选手组成临时组合同台演出。',
    content: [
      '合作舞台环节中，女团成员与选手在短时间内完成编曲与走位磨合，呈现出兼具专业度与综艺感的表现。',
      '现场观众投票显示，多个合作舞台的满意度均超过九成，其中一段抒情改编作品更是引发全场大合唱。',
      '嘉宾表示，网络歌手身上有一种不服输的韧劲，希望未来能有更多跨界的合作机会。',
    ],
    dynamics: [
      { id: 'evt-07-d1', title: '合作舞台花絮曝光 排练过程笑料百出', date: '2026-09-26' },
      { id: 'evt-07-d2', title: '抒情改编舞台出圈 网友集体大合唱', date: '2026-09-24' },
      { id: 'evt-07-d3', title: '晋级名单公布 下周迎来复活赛', date: '2026-09-22' },
    ],
  },
  {
    id: 'evt-08',
    title: '国风舞蹈专场惊艳四座 网红舞蹈赛再掀热潮',
    summary: '网红舞蹈赛推出国风专场，选手们身着华服翩然起舞，将传统美学与现代舞蹈语言完美融合。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20dancer%20mid%20spin%20on%20a%20street%20dance%20battle%20stage%20with%20orange%20and%20cyan%20lighting%2C%20energetic%20pose%2C%20modern%20event%20photography%2C%20clean%20simple%20dark%20background&width=800&height=600&seq=wldg-cover-02&orientation=landscape',
    categoryId: 'dance',
    categoryName: '网红舞蹈赛',
    region: '浙江',
    date: '2026-09-22',
    views: 152000,
    host: '星耀传媒',
    location: '杭州·大剧院',
    tags: ['国风', '舞蹈', '美学'],
    intro: '国风专场是本届舞蹈大赛最具特色的单元，鼓励选手从传统文化中汲取创作灵感。',
    content: [
      '舞台上，选手们以水袖、折扇与剑舞等元素展开表达，配合精心设计的灯光与布景，营造出如诗如画的观感。',
      '评审团从编创、完成度与文化表达三个维度进行打分，多位选手获得了本届赛事的高分评价。',
      '主办方表示，国风专场的成功证明了传统文化与网络文化之间完全可以彼此成就。',
    ],
    dynamics: [
      { id: 'evt-08-d1', title: '国风专场舞美设计幕后揭秘', date: '2026-09-23' },
      { id: 'evt-08-d2', title: '水袖舞蹈片段走红 网友直呼太美', date: '2026-09-21' },
      { id: 'evt-08-d3', title: '下一场现代舞专场阵容公布', date: '2026-09-19' },
    ],
  },
  {
    id: 'evt-09',
    title: '直播间深夜连麦对垒 网红PK赛上演神仙打架',
    summary: '网红PK赛深夜档连麦对决精彩纷呈，多位实力主播在几轮拉锯后仍难分高下，观众直呼过瘾。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    categoryId: 'pk',
    categoryName: '直播PK赛',
    region: '江苏',
    date: '2026-09-19',
    views: 143000,
    host: '每日大瓜赛事组委会',
    location: '线上直播间',
    tags: ['深夜档', '连麦', '拉锯战'],
    intro: '深夜档被视作直播PK赛竞争最激烈的时段，主播们的状态与观众参与度往往都在此时达到峰值。',
    content: [
      '本场对决中，几位主播在积分榜上交替领先，直到最后一轮才分出胜负，连麦过程中的互动与惩罚环节更是看点十足。',
      '观众通过实时弹幕与礼物为喜欢的选手助威，直播间的热度在多个时间点冲上平台榜单前列。',
      '赛事解说表示，这种高强度的拉锯战最能体现主播的临场能力与人格魅力。',
    ],
    dynamics: [
      { id: 'evt-09-d1', title: '深夜档战报 多位主播积分咬紧', date: '2026-09-20' },
      { id: 'evt-09-d2', title: '人气惩罚环节盘点 笑点密集', date: '2026-09-18' },
      { id: 'evt-09-d3', title: '小组赛收官 晋级名单出炉', date: '2026-09-16' },
    ],
  },
  {
    id: 'evt-10',
    title: '助农专场人气爆棚 网红带货赛带火家乡特产',
    summary: '网红带货赛助农专场持续升温，多位主播回到家乡为本地农产品代言，多款特产订单量翻倍增长。',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20livestream%20competition%20event%20in%20a%20sunny%20city%20square%20with%20orange%20banners%20and%20young%20crowd%2C%20festive%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-11&orientation=landscape',
    categoryId: 'ecommerce',
    categoryName: '网红带货赛',
    region: '山东',
    date: '2026-09-16',
    views: 136000,
    host: '优品直播联盟',
    location: '济南·农产品展销中心',
    tags: ['助农', '特产', '订单翻倍'],
    intro: '助农专场鼓励主播深入产地，用真实的镜头语言讲述农产品背后的故事，而非单纯叫卖。',
    content: [
      '多位主播带着镜头走进田间地头，从采摘到打包全程记录，让观众直观感受到产品的品质与诚意。',
      '直播过程中，多款原本知名度有限的地方特产订单量成倍增长，部分农户表示这是第一次有这么多订单同时涌入。',
      '赛事方表示，助农专场不仅是比赛，更是一次让乡村被看见的机会。',
    ],
    dynamics: [
      { id: 'evt-10-d1', title: '产地直播幕后 主播的一天如何度过', date: '2026-09-17' },
      { id: 'evt-10-d2', title: '特产订单暴涨 农户连夜打包发货', date: '2026-09-15' },
      { id: 'evt-10-d3', title: '助农专场收官 成交数据公布', date: '2026-09-13' },
    ],
  },
  {
    id: 'evt-11',
    title: '魔术与杂技同台 才艺挑战赛惊喜不断',
    summary: '才艺挑战赛迎来魔术与杂技专场，近景魔术与高空杂技轮番上演，观众的惊呼声此起彼伏。',
    cover:
      'https://readdy.ai/api/search-image?query=Team%20of%20young%20creators%20collaborating%20on%20a%20live%20stream%20competition%20with%20laptops%20and%20cameras%2C%20warm%20orange%20tones%2C%20modern%20photography%2C%20clean%20background&width=800&height=600&seq=wldg-cover-12&orientation=landscape',
    categoryId: 'talent',
    categoryName: '才艺挑战赛',
    region: '湖北',
    date: '2026-09-12',
    views: 128000,
    host: '江城演出经纪',
    location: '武汉·杂技厅',
    tags: ['魔术', '杂技', '专场'],
    intro: '本场专场的选手多在民间演出多年，才艺挑战赛为他们提供了一个面向全国观众展示的舞台。',
    content: [
      '近景魔术环节中，选手邀请观众上台互动，一连串出人意料的变化让观众哑然失笑又连连称奇。',
      '随后的杂技表演则将现场气氛推向高潮，选手在保证安全的前提下完成了多个高难度动作。',
      '评委表示，这些民间艺人常年在一线打磨技艺，他们的坚持本身就值得被更多人尊重。',
    ],
    dynamics: [
      { id: 'evt-11-d1', title: '近景魔术互动片段走红网络', date: '2026-09-13' },
      { id: 'evt-11-d2', title: '杂技选手专访 台上一分钟台下十年功', date: '2026-09-11' },
      { id: 'evt-11-d3', title: '下场语言类专场预告发布', date: '2026-09-09' },
    ],
  },
  {
    id: 'evt-12',
    title: '校园公益主播计划启动 网红公益赛走进高校',
    summary: '公益主播赛联合多所高校发起校园公益计划，鼓励学生用直播讲述身边的正能量故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Group%20of%20friendly%20young%20streamers%20volunteering%20at%20a%20charity%20broadcast%20event%20with%20orange%20warm%20tones%2C%20smiling%20faces%2C%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-06&orientation=landscape',
    categoryId: 'charity',
    categoryName: '公益主播赛',
    region: '上海',
    date: '2026-09-08',
    views: 119000,
    host: '每日大瓜公益基金',
    location: '上海·大学生活动中心',
    tags: ['校园', '公益', '计划'],
    intro: '校园公益计划面向全国高校学生开放，参赛者可以个人或社团形式报名参与。',
    content: [
      '计划启动现场，多位往届公益主播走进校园分享经验，鼓励学生把镜头对准身边的平凡善举。',
      '参与学生将围绕乡村振兴、环境保护与助老助残等主题进行创作，优秀作品将获得专项支持。',
      '主办方希望借助年轻创作者的力量，让公益成为一种更日常、更可持续的表达方式。',
    ],
    dynamics: [
      { id: 'evt-12-d1', title: '校园计划报名通道开启 首日报名踊跃', date: '2026-09-09' },
      { id: 'evt-12-d2', title: '往届公益主播进校园分享会回顾', date: '2026-09-07' },
      { id: 'evt-12-d3', title: '高校社团创作主题公布', date: '2026-09-05' },
    ],
  },
  {
    id: 'evt-13',
    title: '高音挑战引爆现场 歌唱大赛复活赛名额揭晓',
    summary: '歌唱大赛高音挑战环节异常激烈，多位选手挑战高难度曲目，复活赛名额最终尘埃落定。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20female%20singer%20performing%20on%20a%20colorful%20competition%20stage%20with%20warm%20orange%20spotlight%2C%20microphone%20in%20hand%2C%20modern%20event%20photography%2C%20clean%20bright%20simple%20studio%20background&width=800&height=600&seq=wldg-cover-01&orientation=landscape',
    categoryId: 'singing',
    categoryName: '网红歌唱赛',
    region: '北京',
    date: '2026-09-04',
    views: 112000,
    host: '每日大瓜赛事组委会',
    location: '北京·音乐厅',
    tags: ['高音', '复活赛', '挑战'],
    intro: '复活赛为在初赛中惜败的选手提供了再次证明自己的机会，也是历届赛事话题度最高的环节之一。',
    content: [
      '本轮以一个高音挑战作为开场，选手们需要在指定曲目中完成难度最高的段落，现场气氛一度紧张到极点。',
      '多位选手的稳定发挥赢得评委认可，也有选手虽然出现小失误，却凭借情感表达打动了观众。',
      '最终复活赛名额在综合评分后正式公布，晋级选手将在半决赛中迎来更强对手。',
    ],
    dynamics: [
      { id: 'evt-13-d1', title: '高音挑战名场面盘点', date: '2026-09-05' },
      { id: 'evt-13-d2', title: '复活选手专访：我不想留遗憾', date: '2026-09-03' },
      { id: 'evt-13-d3', title: '半决赛曲目单曝光 悬念拉满', date: '2026-09-01' },
    ],
  },
  {
    id: 'evt-14',
    title: '街舞Battle赛制升级 网红舞蹈大赛看点十足',
    summary: '网红舞蹈大赛引入全新Battle赛制，选手即兴对决，实力与临场反应成为晋级的关键。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20dancer%20mid%20spin%20on%20a%20street%20dance%20battle%20stage%20with%20orange%20and%20cyan%20lighting%2C%20energetic%20pose%2C%20modern%20event%20photography%2C%20clean%20simple%20dark%20background&width=800&height=600&seq=wldg-cover-02&orientation=landscape',
    categoryId: 'dance',
    categoryName: '网红舞蹈赛',
    region: '广东',
    date: '2026-08-30',
    views: 105000,
    host: '星耀传媒',
    location: '深圳·潮流音乐厅',
    tags: ['Battle', '即兴', '赛制'],
    intro: 'Battle赛制取消了事先排练的环节，选手需要在音乐响起的瞬间完成即兴编舞，充分考验综合实力。',
    content: [
      '全新的赛制让比赛节奏明显加快，选手们在一轮轮即兴对决中不断突破自我，现场欢呼声此起彼伏。',
      '有选手坦言，即兴Battle远比排练好的作品更考验心态，但也更能激发真实的舞蹈状态。',
      '赛事方表示，未来将保留Battle环节作为特色设置，让舞蹈比赛回归最纯粹的表达。',
    ],
    dynamics: [
      { id: 'evt-14-d1', title: 'Battle名场面合集 燃到头皮发麻', date: '2026-08-31' },
      { id: 'evt-14-d2', title: '选手即兴编舞技巧解读', date: '2026-08-29' },
      { id: 'evt-14-d3', title: '舞蹈大赛赛程过半 晋级形势明朗', date: '2026-08-27' },
    ],
  },
  {
    id: 'evt-15',
    title: '双人PK赛制上线 网红PK赛团队战一触即发',
    summary: '网红PK赛推出双人组队赛制，主播之间需要互相配合，团队协作成为胜负的新变量。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    categoryId: 'pk',
    categoryName: '直播PK赛',
    region: '四川',
    date: '2026-08-26',
    views: 98000,
    host: '每日大瓜赛事组委会',
    location: '成都·直播基地',
    tags: ['双人组队', '团队', '赛制'],
    intro: '双人组队赛制要求两位主播在赛前完成分工，通过配合提升整体表现，个人英雄主义难以奏效。',
    content: [
      '首轮组队赛中，几对临时搭档从陌生到默契，配合过程中的磨合细节成为观众津津乐道的话题。',
      '赛事解说指出，团队赛让直播PK有了更多战术层面的看点，也让观众看到主播们不同的一面。',
      '晋级的组合将在后续赛事中继续保持搭档，向冠军发起冲击。',
    ],
    dynamics: [
      { id: 'evt-15-d1', title: '组队赛首轮战报 黑马组合杀出重围', date: '2026-08-27' },
      { id: 'evt-15-d2', title: '主播默契度测试花絮公开', date: '2026-08-25' },
      { id: 'evt-15-d3', title: '团队赛完整赛程发布', date: '2026-08-23' },
    ],
  },
  {
    id: 'evt-16',
    title: '美妆带货赛道激战 网红带货赛迎新晋黑马',
    summary: '美妆赛道竞争愈发激烈，一位新晋主播凭借专业的成分讲解与真诚的推荐风格迅速脱颖而出。',
    cover:
      'https://readdy.ai/api/search-image?query=Smiling%20young%20host%20presenting%20products%20during%20a%20lively%20live%20selling%20show%20with%20orange%20accents%2C%20bright%20studio%20lighting%2C%20modern%20e-commerce%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-04&orientation=landscape',
    categoryId: 'ecommerce',
    categoryName: '网红带货赛',
    region: '浙江',
    date: '2026-08-22',
    views: 92000,
    host: '优品直播联盟',
    location: '杭州·直播电商园',
    tags: ['美妆', '黑马', '专业'],
    intro: '美妆赛道历来是带货赛的焦点，参赛主播不仅要比拼转化，还要接受专业评委对产品知识的考核。',
    content: [
      '一位此前关注度并不高的主播在多轮讲解中展现了扎实的成分知识，并用平实的方式解答观众疑问，逐渐积累起口碑。',
      '在评分环节，她的专业度与真实感获得评委一致认可，成为本轮最大的黑马。',
      '多位主播表示，观众越来越理性，只有真正了解产品的推荐才能走得更远。',
    ],
    dynamics: [
      { id: 'evt-16-d1', title: '黑马主播专访 专业才是长期主义', date: '2026-08-23' },
      { id: 'evt-16-d2', title: '美妆赛道评分标准公开', date: '2026-08-21' },
      { id: 'evt-16-d3', title: '下场数码专场预告', date: '2026-08-19' },
    ],
  },
  {
    id: 'evt-17',
    title: '乐器达人惊艳亮相 才艺挑战赛音乐专场好评如潮',
    summary: '才艺挑战赛音乐专场汇聚众多乐器达人，古典与流行同台碰撞，现场宛如一场高品质音乐会。',
    cover:
      'https://readdy.ai/api/search-image?query=Talented%20young%20performer%20showing%20skills%20on%20a%20variety%20talent%20stage%20with%20warm%20gold%20orange%20lighting%2C%20excited%20expression%2C%20modern%20event%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-05&orientation=landscape',
    categoryId: 'talent',
    categoryName: '才艺挑战赛',
    region: '江苏',
    date: '2026-08-18',
    views: 86000,
    host: '金陵文化',
    location: '南京·音乐厅',
    tags: ['乐器', '音乐', '专场'],
    intro: '音乐专场鼓励选手用乐器讲述自己的故事，评委更看重演奏中的情感与个性表达。',
    content: [
      '从古筝、琵琶到爵士鼓、合成器，选手们用截然不同的乐器语言完成了一场跨越风格的对话。',
      '其中一位选手将传统曲目改编为融合电子元素的版本，让评委与观众都耳目一新。',
      '主办方表示，音乐专场的好评超出预期，未来将考虑把它扩展为独立的系列赛事。',
    ],
    dynamics: [
      { id: 'evt-17-d1', title: '传统曲目改编版本出圈', date: '2026-08-19' },
      { id: 'evt-17-d2', title: '乐器达人后台排练揭秘', date: '2026-08-17' },
      { id: 'evt-17-d3', title: '音乐专场完整回放上线', date: '2026-08-15' },
    ],
  },
  {
    id: 'evt-18',
    title: '乡村振兴公益直播 网红公益赛助农成绩亮眼',
    summary: '公益主播赛走进乡村振兴一线，主播们用连续多日的直播为偏远地区农产品打开销路。',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20livestream%20competition%20event%20in%20a%20sunny%20city%20square%20with%20orange%20banners%20and%20young%20crowd%2C%20festive%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-11&orientation=landscape',
    categoryId: 'charity',
    categoryName: '公益主播赛',
    region: '湖南',
    date: '2026-08-14',
    views: 81000,
    host: '每日大瓜公益基金',
    location: '湘西·乡村合作社',
    tags: ['乡村振兴', '助农', '直播'],
    intro: '本次公益直播历时多日，主播们驻扎乡村，与农户同吃同住，用镜头记录真实的产地故事。',
    content: [
      '连续多日的直播让观众看到了农产品从种植到收获的全过程，也拉近了城市消费者与乡村之间的距离。',
      '多款特色农产品在直播后形成稳定订单，为当地合作社带来了持续的销售渠道。',
      '公益赛相关负责人表示，帮助农户建立长期能力，比一次性的销量更有价值。',
    ],
    dynamics: [
      { id: 'evt-18-d1', title: '乡村直播日记 主播与农户的日常', date: '2026-08-15' },
      { id: 'evt-18-d2', title: '合作社订单持续增长', date: '2026-08-13' },
      { id: 'evt-18-d3', title: '公益助农模式引发讨论', date: '2026-08-11' },
    ],
  },
  {
    id: 'evt-19',
    title: '歌唱大赛半决赛落幕 十强选手名单正式公布',
    summary: '经过激烈角逐，歌唱大赛半决赛圆满结束，十位选手突出重围，晋级年度总决赛。',
    cover:
      'https://readdy.ai/api/search-image?query=Winner%20holding%20a%20golden%20trophy%20on%20an%20award%20stage%20with%20orange%20warm%20spotlights%20and%20confetti%2C%20happy%20young%20host%2C%20modern%20event%20photography%2C%20clean%20background&width=800&height=600&seq=wldg-cover-08&orientation=landscape',
    categoryId: 'singing',
    categoryName: '网红歌唱赛',
    region: '山东',
    date: '2026-08-10',
    views: 77000,
    host: '每日大瓜赛事组委会',
    location: '青岛·大剧院',
    tags: ['半决赛', '十强', '晋级'],
    intro: '半决赛是通往总决赛的最后一道关卡，选手们都拿出了状态最好的一次表演。',
    content: [
      '本场赛事采用分组对抗的形式，每组选手演唱后由评委与观众共同打分，竞争异常激烈。',
      '十强名单公布的那一刻，现场掌声与欢呼交织，有选手激动落泪，也有选手互相拥抱祝贺。',
      '组委会透露，总决赛将升级舞台规格，并邀请更多明星嘉宾到场助阵。',
    ],
    dynamics: [
      { id: 'evt-19-d1', title: '十强选手合影曝光 总决赛蓄势待发', date: '2026-08-11' },
      { id: 'evt-19-d2', title: '半决赛高光时刻回顾', date: '2026-08-09' },
      { id: 'evt-19-d3', title: '总决赛舞台设计抢先看', date: '2026-08-07' },
    ],
  },
  {
    id: 'evt-20',
    title: '爵士与街舞碰撞 网红舞蹈大赛跨界合作引热议',
    summary: '网红舞蹈大赛推出跨界合作舞台，爵士与街舞舞者同台共创，打破舞种边界带来全新观感。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20dancer%20mid%20spin%20on%20a%20street%20dance%20battle%20stage%20with%20orange%20and%20cyan%20lighting%2C%20energetic%20pose%2C%20modern%20event%20photography%2C%20clean%20simple%20dark%20background&width=800&height=600&seq=wldg-cover-02&orientation=landscape',
    categoryId: 'dance',
    categoryName: '网红舞蹈赛',
    region: '北京',
    date: '2026-08-05',
    views: 73000,
    host: '星耀传媒',
    location: '北京·舞蹈剧场',
    tags: ['跨界', '爵士', '街舞'],
    intro: '跨界合作舞台鼓励不同舞种的选手组成临时的共创小组，用融合的方式呈现一支全新作品。',
    content: [
      '爵士舞者与街舞舞者在排练中反复磨合节奏与风格，最终呈现的作品既保留了各自的特色，又形成了新的整体。',
      '观众表示，这种跨界合作让人看到了舞蹈的更多可能性，也让不同圈层的粉丝走到了一起。',
      '赛事方表示，跨界合作将成为后续赛事的固定环节，继续探索舞蹈表达的边界。',
    ],
    dynamics: [
      { id: 'evt-20-d1', title: '跨界合作舞台完整版上线', date: '2026-08-06' },
      { id: 'evt-20-d2', title: '两组舞者共创幕后记录', date: '2026-08-04' },
      { id: 'evt-20-d3', title: '舞蹈大赛收视再创新高', date: '2026-08-02' },
    ],
  },
  {
    id: 'evt-21',
    title: '连麦惩罚花样百出 网红PK赛趣味赛制圈粉无数',
    summary: '网红PK赛在赛制中加入趣味惩罚环节，主播们的真实反应让直播间笑声不断，也让赛事更具综艺感。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    categoryId: 'pk',
    categoryName: '直播PK赛',
    region: '湖北',
    date: '2026-07-30',
    views: 69000,
    host: '每日大瓜赛事组委会',
    location: '线上直播间',
    tags: ['惩罚环节', '综艺感', '圈粉'],
    intro: '趣味惩罚是本赛事的传统环节，旨在让紧张的对决多一些轻松与真实的笑点。',
    content: [
      '本轮赛事中，落败的主播需要完成观众投票选出的惩罚任务，主播们的反应往往比比赛本身更让人捧腹。',
      '有主播在惩罚环节展现了意想不到的才艺，反而因此涨了不少粉丝，被网友戏称为“因祸得福”。',
      '赛事解说表示，这些真实的互动正是直播PK区别于传统综艺的魅力所在。',
    ],
    dynamics: [
      { id: 'evt-21-d1', title: '惩罚环节名场面合集', date: '2026-07-31' },
      { id: 'evt-21-d2', title: '主播因惩罚意外走红', date: '2026-07-29' },
      { id: 'evt-21-d3', title: '观众投票选出最想看的惩罚', date: '2026-07-27' },
    ],
  },
  {
    id: 'evt-22',
    title: '数码专场成交惊人 网红带货赛科技品类受追捧',
    summary: '网红带货赛数码专场人气爆棚，多款科技新品在直播间首发，成交数据再次刷新赛事纪录。',
    cover:
      'https://readdy.ai/api/search-image?query=Smiling%20young%20host%20presenting%20products%20during%20a%20lively%20live%20selling%20show%20with%20orange%20accents%2C%20bright%20studio%20lighting%2C%20modern%20e-commerce%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-04&orientation=landscape',
    categoryId: 'ecommerce',
    categoryName: '网红带货赛',
    region: '上海',
    date: '2026-07-25',
    views: 66000,
    host: '优品直播联盟',
    location: '上海·科技会展中心',
    tags: ['数码', '首发', '科技'],
    intro: '数码专场是带货赛中门槛最高的赛道之一，主播需要具备扎实的产品知识与清晰的讲解能力。',
    content: [
      '多款科技新品选择在赛事直播间完成首发，主播们通过实测与对比的方式向观众呈现产品特性。',
      '成交数据显示，具备专业讲解能力的主播在数码品类上的转化明显更高，印证了内容质量的重要性。',
      '品牌方表示，希望能与更多专业主播建立长期合作，让好产品被更多人了解。',
    ],
    dynamics: [
      { id: 'evt-22-d1', title: '数码专场战报 多款新品售罄', date: '2026-07-26' },
      { id: 'evt-22-d2', title: '主播实测视频引发科技圈讨论', date: '2026-07-24' },
      { id: 'evt-22-d3', title: '品牌与主播合作模式解读', date: '2026-07-22' },
    ],
  },
  {
    id: 'evt-23',
    title: '脱口秀新星诞生 才艺挑战赛语言专场笑点密集',
    summary: '才艺挑战赛语言专场迎来一批脱口秀新人，生活化的段子引发全场共鸣，笑声几乎没停过。',
    cover:
      'https://readdy.ai/api/search-image?query=Journalist%20interviewing%20a%20young%20popular%20streamer%20with%20microphone%20after%20a%20contest%2C%20orange%20accent%20lighting%2C%20modern%20media%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-10&orientation=landscape',
    categoryId: 'talent',
    categoryName: '才艺挑战赛',
    region: '广东',
    date: '2026-07-20',
    views: 63000,
    host: '粤新文创',
    location: '广州·小剧场',
    tags: ['脱口秀', '语言', '新人'],
    intro: '语言专场为热爱表达的创作者提供了舞台，选手们用幽默讲述普通人的日常。',
    content: [
      '从职场吐槽到生活观察，选手们的段子取材于真实经历，让台下观众频频点头并爆发出笑声。',
      '一位初次登台的新人凭借自然的节奏与真诚的表达获得了好评，被评委称为“最有潜力的黑马”。',
      '主办方表示，将继续为语言类创作者提供更多演出与曝光机会。',
    ],
    dynamics: [
      { id: 'evt-23-d1', title: '语言专场爆笑片段合集', date: '2026-07-21' },
      { id: 'evt-23-d2', title: '新人选手专访 从零开始的舞台', date: '2026-07-19' },
      { id: 'evt-23-d3', title: '线下开放麦计划发布', date: '2026-07-17' },
    ],
  },
  {
    id: 'evt-24',
    title: '山区支教公益行 网红公益赛记录暖心瞬间',
    summary: '公益主播赛团队走进山区学校，用直播记录支教日常，许多观众被孩子们的纯真与坚持打动。',
    cover:
      'https://readdy.ai/api/search-image?query=Group%20of%20friendly%20young%20streamers%20volunteering%20at%20a%20charity%20broadcast%20event%20with%20orange%20warm%20tones%2C%20smiling%20faces%2C%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-06&orientation=landscape',
    categoryId: 'charity',
    categoryName: '公益主播赛',
    region: '四川',
    date: '2026-07-15',
    views: 60000,
    host: '每日大瓜公益基金',
    location: '凉山·乡村小学',
    tags: ['支教', '公益', '暖心'],
    intro: '山区支教公益行是本届公益赛的重点项目，主播们把镜头对准了孩子们最真实的日常。',
    content: [
      '连续几天的直播记录了课堂、课间与家访，观众们通过这些画面了解了山区教育的现状与需求。',
      '有观众在直播后自发联系公益基金，希望为学校捐赠图书与文具，让善意持续传递。',
      '主播们表示，比起直播数据，孩子们的笑脸才是最珍贵的收获。',
    ],
    dynamics: [
      { id: 'evt-24-d1', title: '支教日记连载 记录最真实的课堂', date: '2026-07-16' },
      { id: 'evt-24-d2', title: '爱心图书捐赠通道开启', date: '2026-07-14' },
      { id: 'evt-24-d3', title: '公益行收官 孩子们手写信曝光', date: '2026-07-12' },
    ],
  },
  {
    id: 'evt-25',
    title: '经典金曲翻唱热潮 歌唱大赛人气选手引回忆杀',
    summary: '歌唱大赛掀起经典翻唱热潮，选手们重新演绎多首金曲，唤起了观众的集体回忆。',
    cover:
      'https://readdy.ai/api/search-image?query=Backstage%20scene%20of%20young%20streamers%20preparing%20makeup%20and%20equipment%20before%20a%20show%20with%20warm%20orange%20lighting%2C%20candid%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-09&orientation=landscape',
    categoryId: 'singing',
    categoryName: '网红歌唱赛',
    region: '江苏',
    date: '2026-07-08',
    views: 57000,
    host: '每日大瓜赛事组委会',
    location: '苏州·文化艺术中心',
    tags: ['金曲', '翻唱', '回忆'],
    intro: '本轮赛事以“致敬经典”为主题，鼓励选手从华语乐坛的经典作品中挑选曲目进行再创作。',
    content: [
      '选手们在保留原曲韵味的基础上加入了各自的风格，让老歌在新的演绎中焕发了新的生命力。',
      '多首翻唱作品引发了观众的热烈讨论，相关话题连续两天登上社交平台热搜。',
      '评委表示，经典之所以成为经典，正因为它能被一代又一代人重新理解和传唱。',
    ],
    dynamics: [
      { id: 'evt-25-d1', title: '经典翻唱合集上线 引发集体回忆', date: '2026-07-09' },
      { id: 'evt-25-d2', title: '原唱作者为选手点赞', date: '2026-07-07' },
      { id: 'evt-25-d3', title: '下轮主题公布 原创作品专场', date: '2026-07-05' },
    ],
  },
  {
    id: 'evt-26',
    title: '拉丁舞者优雅登场 网红舞蹈大赛多元舞种齐放',
    summary: '网红舞蹈大赛迎来拉丁舞单元，选手们用优雅与爆发力兼具的表现，展现了舞种的独特魅力。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20dancer%20mid%20spin%20on%20a%20street%20dance%20battle%20stage%20with%20orange%20and%20cyan%20lighting%2C%20energetic%20pose%2C%20modern%20event%20photography%2C%20clean%20simple%20dark%20background&width=800&height=600&seq=wldg-cover-02&orientation=landscape',
    categoryId: 'dance',
    categoryName: '网红舞蹈赛',
    region: '湖南',
    date: '2026-06-28',
    views: 54000,
    host: '星耀传媒',
    location: '长沙·大剧院',
    tags: ['拉丁舞', '多元', '优雅'],
    intro: '舞蹈大赛始终鼓励多种舞种同台，让不同风格的舞者都能找到属于自己的舞台。',
    content: [
      '拉丁舞单元中，选手们以饱满的情感与精准的节奏完成了表演，舞台张力十足。',
      '与其他舞种的同台也让观众直观感受到舞蹈的多样性，不少网友表示第一次认真了解了拉丁舞。',
      '赛事方表示，多元舞种是舞蹈大赛一直坚持的方向，未来会继续保持开放。',
    ],
    dynamics: [
      { id: 'evt-26-d1', title: '拉丁舞单元精彩回顾', date: '2026-06-29' },
      { id: 'evt-26-d2', title: '舞种科普系列短片上线', date: '2026-06-27' },
      { id: 'evt-26-d3', title: '舞蹈大赛多元发展引关注', date: '2026-06-25' },
    ],
  },
  {
    id: 'evt-27',
    title: '跨平台联动PK赛 网红主播同台竞技破圈传播',
    summary: '网红PK赛尝试跨平台联动赛制，来自不同平台的主播同台竞技，让赛事影响力突破圈层。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    categoryId: 'pk',
    categoryName: '直播PK赛',
    region: '浙江',
    date: '2026-06-18',
    views: 51000,
    host: '每日大瓜赛事组委会',
    location: '线上直播间',
    tags: ['跨平台', '联动', '破圈'],
    intro: '跨平台联动是本届PK赛的一次创新尝试，旨在打破平台壁垒，让优质主播获得更大的展示空间。',
    content: [
      '来自不同平台的主播在统一规则下展开对决，观众可以在多个入口观看并参与互动。',
      '赛事数据显示，跨平台联动有效扩大了受众范围，一批原本局限在小圈层的主播被更多人认识。',
      '组委会表示，将继续探索跨平台合作的更多可能，推动网红行业更加开放。',
    ],
    dynamics: [
      { id: 'evt-27-d1', title: '跨平台联动赛果公布', date: '2026-06-19' },
      { id: 'evt-27-d2', title: '跨平台合作模式引发行业讨论', date: '2026-06-17' },
      { id: 'evt-27-d3', title: '主播跨平台发展现状观察', date: '2026-06-15' },
    ],
  },
  {
    id: 'evt-28',
    title: '国货专场实力圈粉 网红带货赛助推本土品牌',
    summary: '网红带货赛国货专场成绩亮眼，越来越多的消费者通过直播间认识并支持本土品牌。',
    cover:
      'https://readdy.ai/api/search-image?query=Team%20of%20young%20creators%20collaborating%20on%20a%20live%20stream%20competition%20with%20laptops%20and%20cameras%2C%20warm%20orange%20tones%2C%20modern%20photography%2C%20clean%20background&width=800&height=600&seq=wldg-cover-12&orientation=landscape',
    categoryId: 'ecommerce',
    categoryName: '网红带货赛',
    region: '山东',
    date: '2026-06-08',
    views: 48000,
    host: '优品直播联盟',
    location: '青岛·国货展销中心',
    tags: ['国货', '本土品牌', '专场'],
    intro: '国货专场旨在为本土品牌搭建展示与销售的桥梁，让用心做产品的品牌被更多人看见。',
    content: [
      '赛事中，主播们深入走访工厂与研发中心，用镜头展现国货品牌在产品与设计上的用心。',
      '多款本土产品在直播间收获了超出预期的订单，品牌方表示这是与消费者直接对话的宝贵机会。',
      '赛事方表示，将把国货专场常态化，持续助力本土品牌成长。',
    ],
    dynamics: [
      { id: 'evt-28-d1', title: '国货专场战报 多款产品热销', date: '2026-06-09' },
      { id: 'evt-28-d2', title: '主播探厂实录 见证国货品质', date: '2026-06-07' },
      { id: 'evt-28-d3', title: '国货专场将常态化举办', date: '2026-06-05' },
    ],
  },
];